import React from 'react';
import PropTypes from 'prop-types';

// Redux form
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';

import submit from './submit';
import validate from './validate';

// Locale
import messages from '../../locale/jsonMessages';

// Style
import {
  Button,
  FormGroup,
  FormControl,

} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

//Images
import ShowPassword from '/public/SiteIcons/pswVisible.svg';
import HidePassword from '/public/SiteIcons/pwdHidden.svg';

import cs from '../../components/commonStyle.css';
import s from './ChangePasswordForm.css';

class ChangePasswordForm extends React.Component {

  static propTypes = {
    formatMessage: PropTypes.any,
    initialValues: PropTypes.shape({
      registeredType: PropTypes.string.isRequired,
    }).isRequired
  };

  static defaultProps = {
    initialValues: {
      registeredType: 'email'
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      oldPassword: false,
      newPassword: false,
      confirmPassword: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(fieldName) {
    this.setState({ [fieldName]: !this.state[fieldName] });
  }

  renderFormControl = ({ input, label, type, meta: { touched, error }, showPassword, placeholder, isRequiredInput }) => {
    const { formatMessage } = this.props.intl;
    return (
      <FormGroup className={cs.noMargin}>
        <label className='commonLabelText'><span>{label}{isRequiredInput && <sup className='isRequiredStar'>*</sup>}</span></label>
        <div className={cs.positionRelative}>
          <FormControl {...input} type={showPassword ? input : type} className='commonInputField commonRightSideIconInput' placeholder={placeholder} maxLength={25} autoComplete={"off"} />
          {type == 'password' && <span onClick={() => this.handleChange(input.name)} className='passwordShowHideIcon'>
            {showPassword ? <img src={ShowPassword} /> : <img src={HidePassword} />}
          </span>}
        </div>
        {touched && error && <span className='errorMessageText'>{formatMessage(error)}</span>}
      </FormGroup>
    );
  }

  render() {
    const { error, handleSubmit, submitting, dispatch, initialValues, title } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className={cx(cs.commonBorderSection, 'whiteBgColor')}>
        <h3 className={cx(cs.commonTotalText, cs.spaceBottom4)}><FormattedMessage {...messages.changePassword} /></h3>
        <form onSubmit={handleSubmit(submit)} autoComplete={"off"}>
          {error && <strong>{error}</strong>}
          <div className="oneColumnGrid">
            {
              initialValues && initialValues.registeredType === 'email' &&
              <Field
                name="oldPassword"
                type="password"
                component={this.renderFormControl}
                label={formatMessage(messages.oldPassword)}
                showPassword={this.state.oldPassword}
                placeholder={formatMessage(messages.enterOldPassword)}
                isRequiredInput
              />
            }
            <Field
              name="newPassword"
              type="password"
              component={this.renderFormControl}
              showPassword={this.state.newPassword}
              label={formatMessage(messages.newPassword)}
              placeholder={formatMessage(messages.newPassword)}
              isRequiredInput />

            <Field
              name="confirmPassword"
              type="password"
              component={this.renderFormControl}
              showPassword={this.state.confirmPassword}
              label={formatMessage(messages.confirmNewPassword)}
              placeholder={formatMessage(messages.confirmNewPassword)}
              isRequiredInput />
          </div>

          <div className={cx('singleBtnFlexEnd', cs.spaceTop4)}>
            <Button className={cs.btnPrimary} type="submit" disabled={submitting}>
              <FormattedMessage {...messages.updatePassword} />
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

ChangePasswordForm = reduxForm({
  form: 'ChangePasswordForm', // a unique name for this form
  validate
})(ChangePasswordForm);

export default injectIntl(withStyles(cs, s)(ChangePasswordForm));